<template>
    <div class="w-1/3 border border-gray-200 rounded-xl shadow">
        <div class="flex flex-col p-5">
            <span class="text-base font-bold mb-5">
                {{ props.title }}
            </span>
            <span class="text-4xl font-bold">
                {{ props.dataNumber }}
            </span>
            <div class="flex justify-between">
                <div class="flex mt-5">
                    <hi-arrow-up-icon
                        v-if="props.type === 'success'"
                        class="h-5 w-5 fill-green-800" />
                    <hi-arrow-down-icon
                        v-else
                        class="h-5 w-5 fill-error-800" />
                    <span :class="[props.type === 'success' ? 'text-base text-green-800' : 'text-base text-error-800']">
                        {{ props.rate }}
                    </span>
                    <span class="text-base ml-2">
                        {{ $t('labels.withPreMonth') }}
                    </span>
                </div>
                <div class="w-60">
                    <hts-chart-line
                        :height="50"
                        :datasets="props.datasets"
                        :labels="props.labels"
                        :chart-options="props.chartOptions" />
                </div>
            </div>
        </div>
        <div class="border-t border-gray-200 flex justify-end p-3">
            <span class="text-base font-bold">
                {{ $t('labels.viewDetail') }}
            </span>
            <hi-arrow-right-icon class="h-5 w-5 fill-black-900" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import colorSize from '~/components/color-size'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  dataNumber: {
    type: String,
    default: ''
  },
  rate: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'success'
  },
  size: {
    /** See in sizeDefault */
    type: String,
    default: ''
  },
  color: {
    /** See in colorDefault */
    type: String,
    default: 'main'
  },
  labels: {
    type: Array<any>,
    default: () => []
  },
  datasets: {
    type: Array<any>,
    default: () => []
  },
  chartOptions: {
    type: Object,
    default: () => {}
  }
})
const { cClass } = colorSize(props)
</script>
